export default __webpack_public_path__ + "static/curvas_nivel-61e11e6669aa133444a4565da4f42040.png";